module.exports = __webpack_public_path__ + "static/media/Fox Costume.80f5a8da.jpg";